import Component from '../core/Component'
import Flickity from 'flickity'
import enquire from 'enquire.js'
import { queries } from '../core/config'

export const STATES = {
    READY: 'is-ready'
}

export default class AwardsSlider extends Component {
    constructor(element, options = {}) {
        super(element, options = {
            itemsPerPage: 3
        })

        this.ref = {
            slider: null,
            prev: null,
            next: null,
            cards: []
        }

        this.enquireHandler = {
            match: () => this.check(),
            unmatch: () => this.check()
        }

        this.mobileFlickity = null
        this.pageIndex = null
        this.activeCards = []
        this.isTransitioning = false
    }

    prepare() {
        this.cards = this.ref.cards.map(cardEl => Component.getFromElement(cardEl))

        enquire.register(queries.largeUp, this.enquireHandler)

        this.ref.prev.addEventListener('click', this.handlePrevClick)
        this.ref.next.addEventListener('click', this.handleNextClick)

        this.check()

        this.element.classList.add(STATES.READY)
    }

    destroy() {
        enquire.unregister(queries.largeUp, this.enquireHandler)
    }
    
    handlePrevClick = () => {
        if (this.mobileFlickity) {
            this.mobileFlickity.previous()
        } else {
            this.selectPreviousPage()
        }
    }

    handleNextClick = () => {
        if (this.mobileFlickity) {
            this.mobileFlickity.next()
        } else {
            this.selectNextPage()
        }
    }

    check() {
        if (window.matchMedia(queries.largeUp).matches) {
            this.destroyMobileFlickity()
            this.createDesktopSlider()
        } else {
            this.createMobileFlickity()
            this.destroyDesktopSlider()
        }
    }

    createMobileFlickity() {
        if (this.mobileFlickity) {
            return
        }

        this.mobileFlickity = new Flickity(this.ref.slider, {
            prevNextButtons: false,
            pageDots: false,
            cellAlign: 'left',
            contain: true
        })

        this.mobileFlickity.on('change', () => this.checkPrevNext())

        this.cards.forEach(card => card.show(false))
    }

    destroyMobileFlickity() {
        this.mobileFlickity?.destroy()
        this.mobileFlickity = null
    }

    createDesktopSlider() {
        this.cards.forEach(card => card.hide(false))
        this.selectPage(0)
    }
    
    destroyDesktopSlider() {
        this.pageIndex = null
    }

    selectPreviousPage() {
        const pageIndex = Math.max(this.pageIndex - 1, 0)
        this.selectPage(pageIndex)
    }

    selectNextPage() {
        const pageIndex = Math.ceil(Math.min(this.pageIndex + 1, this.cards.length / this.options.itemsPerPage - 1))
        this.selectPage(pageIndex)
    }

    selectPage(pageIndex) {
        if (pageIndex === this.pageIndex) {
            return
        }

        this.pageIndex = pageIndex
        this.activeCards.forEach((card, index) => {
            setTimeout(() => {
                card.hide()
            }, index * 200)
        })

        const activeCards = this.cards.slice(pageIndex * this.options.itemsPerPage,pageIndex * this.options.itemsPerPage + this.options.itemsPerPage)

        this.activeCards = activeCards

        activeCards.forEach((card, index) => {
            setTimeout(() => {
                card.show()
            }, index * 200)
        })

        this.checkPrevNext()
    }

    checkPrevNext() {
        const count = this.mobileFlickity ? this.ref.cards.length : Math.ceil(this.ref.cards.length / 3)
        const index = this.mobileFlickity ? this.mobileFlickity.selectedIndex : this.pageIndex

        if (index === count - 1) {
            this.ref.next.classList.remove('is-visible')
        } else {
            this.ref.next.classList.add('is-visible')
        }
    
        if (index === 0) {
            this.ref.prev.classList.remove('is-visible')
        } else {
            this.ref.prev.classList.add('is-visible')
        }
    }
}